import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Wizard Progress Bar Component
 *
 * Displays a progress bar with percentage and current step indicator.
 *
 * Example:
 * [============================----] 70%
 * Schritt 3 von 4: Standort & Kultur
 */
export default function WizardProgress({ currentStep, totalSteps, percent, stepName }) {
  const { t } = useTranslation('brandProfile')

  return (
    <div className="mt-4 space-y-2">
      {/* Progress Bar */}
      <div className="relative">
        <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-blue-600 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${percent}%` }}
          />
        </div>

        {/* Percentage Label */}
        <div className="absolute right-0 -top-6 text-sm font-medium text-gray-600">
          {percent}%
        </div>
      </div>

      {/* Step Indicator */}
      <div className="flex items-center justify-between text-sm">
        <span className="text-gray-600">
          {t('wizard.progress.step', { current: currentStep, total: totalSteps })}
        </span>
        <span className="font-medium text-gray-900 truncate ml-2">
          {stepName}
        </span>
      </div>

      {/* Step Dots */}
      <div className="flex items-center justify-center space-x-2 pt-2">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div
            key={i}
            className={`w-2.5 h-2.5 rounded-full transition-colors duration-200 ${
              i < currentStep
                ? 'bg-blue-600' // Completed
                : i === currentStep - 1
                ? 'bg-blue-600 ring-2 ring-blue-300 ring-offset-2' // Current
                : 'bg-gray-300' // Upcoming
            }`}
          />
        ))}
      </div>
    </div>
  )
}
